import React from 'react';
import PropTypes from 'prop-types';
import SalesUnitProcessFlow from './SalesUnitProcessFlow';

const TeamItem = ({ label, value }) => (
  <div className="tw-flex tw-flex-col sm:tw-flex-row tw-items-baseline tw-gap-0.5 sm:tw-gap-3 tw-py-1.5">
    <span className="sm:tw-w-40 sm:tw-shrink-0 tw-text-xs tw-font-semibold tw-text-slate-500 tw-uppercase tw-tracking-wide">{label}</span>
    <span className="tw-text-sm tw-text-slate-800">{value || <span className="tw-text-slate-300">—</span>}</span>
  </div>
);

TeamItem.propTypes = { label: PropTypes.string.isRequired, value: PropTypes.node };

const SalesUnitDetailInfo = ({ sales_unit, onEditProcessFlow, onApplyConfiguration }) => {
  if (!sales_unit) return null;

  const { sales_admin, sales_leader, sales_tender, sales_manager } = sales_unit;

  const tender = Array.isArray(sales_tender) ? sales_tender.join(', ') : sales_tender;

  return (
    <div className="tw-bg-white tw-rounded-lg tw-border tw-border-slate-200 tw-shadow-sm tw-mb-3">
      <div className="tw-px-5 tw-py-4 tw-border-b tw-border-slate-100">
        <h5 className="tw-text-base tw-font-bold tw-text-slate-800 tw-mb-0">Details</h5>
      </div>

      <div className="tw-px-5 tw-py-4">
        {/* Sales team */}
        <h6 className="tw-text-[11px] tw-font-bold tw-text-primary-600 tw-uppercase tw-tracking-wider tw-mb-3">Sales team</h6>
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-x-10 tw-mb-6">
          <div>
            <TeamItem label="Admin" value={sales_admin} />
            <TeamItem label="Tender" value={tender} />
          </div>
          <div>
            <TeamItem label="Sales leader" value={sales_leader} />
            <TeamItem label="Manager / Chief Rep" value={sales_manager} />
          </div>
        </div>

        {/* Process flow */}
        <SalesUnitProcessFlow salesUnit={sales_unit} onEdit={onEditProcessFlow} onApply={onApplyConfiguration} />
      </div>
    </div>
  );
};

SalesUnitDetailInfo.propTypes = {
  sales_unit: PropTypes.object,
  onEditProcessFlow: PropTypes.func.isRequired,
  onApplyConfiguration: PropTypes.func.isRequired,
};

export default SalesUnitDetailInfo;
